module.exports = __webpack_public_path__ + "static/media/cards-access-restricted.7d1334e8.png";